import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, InputBase } from '@material-ui/core';
import CurrencyFormat from 'react-currency-format';
import { useSelector } from 'react-redux';

const useStyles = makeStyles(() => ({
  inputRoot: {
    width: '100%',
    height: ' 100%',
    paddingRight: 2,
  },
  input: {
    fontSize: 14,
    fontWeight: 400,
  },
}));

const CurrencyTextFilter = ({
                              filterValue,
                              dataKey,
                              onChange,
                            }) => {
  const textInput = useRef(null);

  useEffect(() => {
    if (filterValue === '') {
      textInput.current.value = '';
    } else if (textInput.current.value === '' && filterValue !== null) {
      textInput.current.value = filterValue;
    }
  }, [filterValue]);

  const handleInputChange = (e) => {
    if (onChange) {
      const value = e.target.value.replace('$ ', '');
      onChange(dataKey, value, true);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleInputChange(e);
    }
  };

  return <CurrencyFormat
    inputRef={textInput}
    prefix={'$ '}
    value={filterValue}
    customInput={_CustomInput}
    allowNegative={false}
    fixedDecimalScale={true}
    onKeyDown={handleKeyDown}
    decimalScale={2}
    onBlur={handleInputChange}
    onChange={handleInputChange}
    thousandSeparator={','}
  />;
};

const _CustomInput = (props) => {
  const { en: { tables } } = useSelector((state) => state.i18n);
  const classes = useStyles();
  return <InputBase
    classes={{
      root: classes.inputRoot,
      input: classes.input,
    }}
    placeholder={tables.filter}
    autoComplete='off'
    type='search'
    {...props}
  />;
};


CurrencyTextFilter.propTypes = {
  filterValue: PropTypes.string,
  dataKey: PropTypes.string.isRequired,
  columnData: PropTypes.shape({
    isFilterable: PropTypes.bool,
  }).isRequired,
  onChange: PropTypes.func,
};

CurrencyTextFilter.defaultProps = {
  filterValue: '',
  onChange: undefined,
};

export default CurrencyTextFilter;
